// extracted by mini-css-extract-plugin
export default {"heroBanner":"SolutionsHeroBanner_heroBanner__ssGhK","overlay":"SolutionsHeroBanner_overlay__IJ7i-","title":"SolutionsHeroBanner_title__ZPlAo"};